import Axios from "axios";
import DB from "../../../db";

export const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";
export const FETCH_DATA_RESET = "FETCH_DATA_RESET";

export const fetch_data_request = () => {
  return {
    type: FETCH_DATA_REQUEST,
  };
};

export const fetch_data_success = (result, reload) => {
  return {
    type: FETCH_DATA_SUCCESS,
    payload: { result, reload },
  };
};

export const fetch_data_failure = (error) => {
  return {
    type: FETCH_DATA_FAILURE,
    payload: error,
  };
};

export const fetch_data_reset = () => {
  return {
    type: FETCH_DATA_RESET,
  };
};

export const fetchRequest = (
  url,
  data,
  options,
  type,
  reload = true,
  saveDB = true
) => {
  const db = new DB();
  return (dispatch) => {
    dispatch(fetch_data_request());
    switch (type) {
      case "GET":
        Axios.get(url, options)
          .then((response) => {
            dispatch(fetch_data_success(response.data, reload));
          })
          .catch((err) => dispatch(fetch_data_failure(err.response.data)));
        break;
      case "POST":

        Axios.post(url, data, options)
          .then(async (response) => {
            console.log(response.data)
            if (response.data.result.status === true) {
              dispatch(fetch_data_success(response.data, reload));
            } else {
              dispatch(fetch_data_failure(response.data.result.message));
            }
          })
          .catch((err) => {
            console.log(err.response);
            dispatch(fetch_data_failure(err.response));
          });
        break;
      case "PUT":
        Axios.put(url, data, options)
          .then((response) => {
            dispatch(fetch_data_success(response.data, reload));
          })
          .catch((err) => dispatch(fetch_data_failure(err.response.data)));
        break;
      default:
        Axios.get(url, data, options)
          .then((response) => {
            dispatch(fetch_data_success(response.data, reload));
          })
          .catch((err) => dispatch(fetch_data_failure(err.response.data)));
        break;
    }
  };
};

export const reset = () => {
  return (dispatch) => {
    dispatch(fetch_data_reset());
  };
};

const updateDatabase = (url, response, db) => {
  const promesas = [];
  if (url.includes("set_data.php")) {
    if (response.data.code === "ok") {
      response.data.loads.data.forEach((load) => {
        promesas.push(db.findByIdAndUpdate(load.load_id, load));
      });
    }
  }
  return promesas;
};
